<template>
  <DialogWrapper
    close-on-cancel
    :title="$t(`${i18nPrefix}.title.move`)"
    :show.sync="show"
    :loading="loading"
    @cancel="handleCancel"
    @save="handleSave"
  >
    <WrappedForm
      ref="form"
      hideRequiredAsterisk
      :model="groupInfo"
      :formLines="formLines"
    ></WrappedForm>
  </DialogWrapper>
</template>

<script>
import DialogWrapper from '@/components/dialog/dialogWrapper.vue'
import WrappedForm from '@/components/formEditor/wrappedForm.vue'
import GroupSelector from '../components/candidateGroupSelector.vue'
import _ from 'lodash'

export default {
  components: {
    DialogWrapper,
    WrappedForm
  },
  props: {
    groupList: {
      type: Array,
      required: true
    },
    selectedGroupList: {
      type: Array,
      default: () => []
    }
  },
  data () {
    return {
      i18nPrefix: 'admin.application.candidateGroup',
      show: false,
      loading: false,
      groupInfo: {}
    }
  },
  computed: {
    formLines () {
      const i18nPrefix = this.i18nPrefix
      const requiredMessage = this.$t('common.message.requiredFormField')
      const lines = {
        from: {
          elType: 'el-select',
          label: this.$t(`${i18nPrefix}.label.fromGroup`),
          rules: [{ required: true, message: requiredMessage, trigger: 'change' }],
          props: { filterable: true },
          option: {
            data: this.selectedGroupList,
            labelKey: 'text',
            valueKey: 'id'
          }
        },
        to: {
          elType: GroupSelector,
          label: this.$t(`${i18nPrefix}.label.toGroup`),
          rules: [{ validator: this.validateGroup, trigger: 'change' }],
          props: {
            groupList: this.groupList
          }
        },
        comment: {
          label: this.$t(`${i18nPrefix}.label.comment`),
          props: { type: 'textarea', autosize: { minRows: 5 } }
        }
      }
      return lines
    },
    form () {
      return this.$refs.form
    }
  },
  created () {

  },
  methods: {
    openDialog () {
      this.show = true
    },
    closeDialog () {
      this.show = false
    },
    clearForm () {
      this.groupInfo = { }
      this.$nextTick(() => {
        this.form.clearValidate()
      })
    },
    validateGroup (rule, value, callback) {
      if (!value) {
        callback(new Error(this.$t('common.message.requiredFormField')))
        return
      } else if (!value.id) {
        const found = _.findIndex(this.groupList, { text: value.text }) > -1
        if (found) {
          callback(new Error(this.$t(`${this.i18nPrefix}.message.existedGroupName`)))
          return
        }
      }
      callback()
    },
    async handleSave () {
      if (this.loading) {
        return
      }
      const isValid = await this.$refs.form.submit()
      if (!isValid) {
        return
      }
      this.loading = true
      this.$emit('save', this.groupInfo, close => {
        this.loading = false
        if (close) {
          this.closeDialog()
        }
      })
    },
    handleCancel () {
      this.$emit('cancel')
    }
  },
  watch: {
    show () {
      if (this.show) {
        this.clearForm()
      }
    }
  }
}
</script>

<style lang="scss" scoped>

</style>
